/*
 * Interrupteur de la carte de vente additionnelle du tiroir panier.
 *
 * Element personnalise et non script classique : le tiroir est reconstruit par
 * innerHTML a chaque mise a jour du panier, un listener pose au chargement
 * serait perdu des le premier ajout. Un custom element se reconnecte seul.
 *
 * Le rafraichissement reprend la mecanique des boutons de quantite du tiroir :
 * on remplace le contenu de .drawer__inner et de la pastille panier. On evite
 * volontairement cart-drawer.renderContents, qui rappelle open() en fin de
 * course et fait donc refermer puis rouvrir le tiroir a chaque ajout.
 */
if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      static get sectionsToRender() {
        return [
          { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        ];
      }

      connectedCallback() {
        this.toggle = this.querySelector('.cart-upsell__toggle');
        if (!this.toggle) return;
        this.toggle.addEventListener('click', this.onToggle.bind(this));
      }

      get isInCart() {
        return this.toggle.getAttribute('aria-checked') === 'true';
      }

      onToggle() {
        if (this.busy) return;
        this.busy = true;
        this.classList.add('cart-upsell--busy');
        this.toggle.setAttribute('aria-busy', 'true');

        const wasInCart = this.isInCart;
        // Bascule immediate : le rendu serveur confirmera, mais l'interrupteur
        // ne doit pas rester inerte pendant l'aller-retour reseau.
        this.toggle.setAttribute('aria-checked', wasInCart ? 'false' : 'true');

        (wasInCart ? this.removeLine() : this.addLine())
          .then((state) => {
            if (!state || state.errors || !state.sections) throw new Error('cart update failed');
            this.render(state);
          })
          .catch(() => {
            this.toggle.setAttribute('aria-checked', wasInCart ? 'true' : 'false');
            this.busy = false;
            this.classList.remove('cart-upsell--busy');
            this.toggle.removeAttribute('aria-busy');
          });
      }

      addLine() {
        return this.post(window.routes.cart_add_url, {
          items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
        });
      }

      removeLine() {
        return this.post(window.routes.cart_change_url, {
          id: this.dataset.lineKey,
          quantity: 0,
        });
      }

      post(url, payload) {
        const body = JSON.stringify({
          ...payload,
          sections: CartUpsell.sectionsToRender.map((section) => section.section),
          sections_url: window.location.pathname,
        });

        return fetch(url, { ...fetchConfig(), body }).then((response) => response.json());
      }

      render(state) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof state.item_count === 'number') {
          drawer.classList.toggle('is-empty', state.item_count === 0);
        }

        CartUpsell.sectionsToRender.forEach((section) => {
          const host = document.getElementById(section.id);
          if (!host) return;
          const target = host.querySelector(section.selector) || host;
          target.innerHTML = new DOMParser()
            .parseFromString(state.sections[section.section], 'text/html')
            .querySelector(section.selector).innerHTML;
        });
      }
    }
  );
}
